/* src/app/components/note-article-modal/note-article-modal.component.scss */
.wrapper {
  width: 90%;
  margin: 15px auto;
}
h3 {
  margin-top: 15px;
}
ion-textarea {
  border: 1px solid #E6E6E6;
  border-radius: 10px;
  font-size: 14px;
  --width: 100% !important;
  width: 100% !important;
}
.button-block {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 10px;
}
.button-block .button {
  width: 150px;
}
.button-block_dismiss {
  --background: #fff;
  border: 2px solid var(--ion-color-primary);
  border-radius: 50px;
  --background-hover: #fff;
  --riple-color: #fff;
  --background-focused: #fff;
  color: var(--ion-color-primary);
}
ion-icon {
  width: 19px;
  z-index: 10;
}
/*# sourceMappingURL=note-article-modal.component.css.map */
